import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoayodhyaurbaniabus() {



    const cardData =
    {
        keyword: 'Pune to Ayodhya Urbania Bus On Rent',
        heading: 'Urbania on rent in pune: Pune to Ayodhya Urbania Bus On Rent',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Pune to Ayodhya Urbania Bus On Rent services for pilgrims, families, corporate groups, and travelers planning a comfortable long-distance spiritual journey. Our well-maintained Force Urbania bus fleet provides spacious seating, air-conditioned comfort, ample luggage space, and smooth performance, making it ideal for Ayodhya darshan, group pilgrimages, and religious tours from Pune. With professional chauffeurs experienced in long-route travel, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Pune to Ayodhya Urbania bus hire.',

        top: 'Top Places to Visit in Ayodhya with Pune on rent in pune',


"topPlaces": [
  {
    "title": "Shri Ram Janmabhoomi Temple",
    "description": "Shri Ram Janmabhoomi Temple is the most sacred and significant site in Ayodhya, believed to be the birthplace of Lord Rama. The grand temple complex showcases traditional Nagara-style architecture with intricate carvings, towering shikharas, and a spiritually charged atmosphere. Millions of devotees visit to seek blessings and witness the divine aura of the Ram Lalla idol. The temple stands as a symbol of faith, devotion, and cultural heritage, making Ayodhya a major global pilgrimage destination."
  },
  {
    "title": "Hanuman Garhi",
    "description": "Hanuman Garhi is a prominent hilltop temple dedicated to Lord Hanuman, considered the guardian deity of Ayodhya. Devotees believe that visiting Hanuman Garhi before Ram Janmabhoomi ensures fulfillment of wishes. The temple requires climbing several steps and offers panoramic views of the city. Its vibrant spiritual atmosphere and continuous chanting make it one of Ayodhya’s most visited religious sites."
  },
  {
    "title": "Kanak Bhawan",
    "description": "Kanak Bhawan is a beautiful temple dedicated to Lord Rama and Goddess Sita, believed to have been gifted to Sita by Queen Kaikeyi. The temple is renowned for its richly decorated idols adorned with gold ornaments and royal attire. The peaceful interiors, devotional hymns, and artistic beauty make it a spiritually uplifting experience for devotees and tourists alike."
  },
  {
    "title": "Saryu River Ghat",
    "description": "The Saryu River Ghat is a sacred riverfront where devotees perform holy baths, rituals, and evening aartis. According to legend, Lord Rama took jal samadhi in the Saryu River. The ghats offer a serene environment, especially during sunrise and sunset, when lamps, chants, and reflections create a divine atmosphere. It is a key spiritual and cultural hub of Ayodhya."
  },
  {
    "title": "Dashrath Mahal",
    "description": "Dashrath Mahal is believed to be the royal palace of King Dashrath, the father of Lord Rama. Located near Ram Janmabhoomi, the palace is known for its colorful architecture, decorative balconies, and festive decorations. It plays an important role during Ram Navami celebrations and offers devotees a glimpse into Ayodhya’s mythological royal heritage."
  },
  {
    "title": "Nageshwarnath Temple",
    "description": "Nageshwarnath Temple is an ancient Shiva temple believed to have been established by Kush, the son of Lord Rama. Located near the Saryu River, it is the main center of Shivratri celebrations in Ayodhya. The temple’s historical importance and spiritual calm attract devotees throughout the year."
  },
  {
    "title": "Tulsi Smarak Bhawan",
    "description": "Tulsi Smarak Bhawan is a cultural center dedicated to Goswami Tulsidas, the author of the Ramcharitmanas. The complex includes a library, museum, and auditorium where Ramayana-based performances, kirtans, and cultural programs are held. It serves as a hub for preserving and promoting Ayodhya’s literary and devotional traditions."
  },
  {
    "title": "Ram Katha Park",
    "description": "Ram Katha Park is an open-air cultural venue designed for spiritual discourses, religious gatherings, and Ramayana narrations. The park hosts large-scale events during Ram Navami and other festivals. Its spacious layout and serene surroundings make it ideal for devotional programs and cultural tourism."
  },
  {
    "title": "Guptar Ghat",
    "description": "Guptar Ghat is believed to be the sacred site where Lord Rama is said to have taken jal samadhi. Located along the Saryu River, the ghat features several small temples and peaceful surroundings. It is less crowded compared to other ghats, making it ideal for meditation, prayer, and quiet reflection."
  },
  {
    "title": "Treta Ke Thakur Temple",
    "description": "Treta Ke Thakur Temple is believed to mark the site where Lord Rama performed the Ashwamedha Yagna. The temple houses ancient idols of Rama, Sita, Lakshmana, Hanuman, and Bharat carved from black stone. Accessible only on specific days, the temple holds immense mythological and spiritual importance for devotees visiting Ayodhya."
  }
],




"services": [
{
"name": "Pune to Ayodhya Urbania Bus on Rent",
"description": "Pune to Ayodhya Urbania Bus on Rent offers comfortable and reliable Urbania buses for long-distance pilgrimage travel. The service is ideal for devotees and groups visiting Ayodhya, providing spacious seating, clean interiors, ample luggage space, and experienced drivers to ensure a safe and peaceful journey from Pune."
},
{
"name": "Ayodhya Urbania Hire from Pune",
"description": "Ayodhya Urbania Hire from Pune provides flexible Urbania bus rental options for one-way and round-trip travel. Designed for families and group pilgrims, the service focuses on punctual departures, smooth travel, and comfortable seating throughout the journey."
},
{
"name": "Urbania Bus Rental Pune to Ayodhya",
"description": "Urbania Bus Rental Pune to Ayodhya offers well-maintained buses suitable for extended highway travel. With reliable performance, professional chauffeurs, and passenger-friendly interiors, it ensures a relaxed and secure pilgrimage experience."
},
{
"name": "Urbania AC Bus Pune to Ayodhya",
"description": "Urbania AC Bus Pune to Ayodhya provides fully air-conditioned Urbania buses for a comfortable and climate-controlled journey. This option is especially suitable for families, senior citizens, and travelers seeking added comfort on long routes."
},
{
"name": "Pune Ayodhya Urbania One Way Hire",
"description": "Pune Ayodhya Urbania One Way Hire offers convenient one-way travel solutions for devotees traveling from Pune to Ayodhya. The service ensures timely pickup, professional driving, and a hassle-free travel experience."
},
{
"name": "Pune Ayodhya Urbania Round Trip Hire",
"description": "Pune Ayodhya Urbania Round Trip Hire provides complete round-trip transportation with well-planned schedules, allowing travelers to focus on darshan and spiritual activities without travel concerns."
},
{
"name": "Corporate Urbania Pune to Ayodhya",
"description": "Corporate Urbania Pune to Ayodhya offers organized and professional transport solutions for corporate groups and institutions planning pilgrimage or group tours, ensuring punctuality, comfort, and smooth coordination."
},
{
"name": "Family Tour Urbania Pune to Ayodhya",
"description": "Family Tour Urbania Pune to Ayodhya is designed to provide a safe, spacious, and comfortable travel environment for families, making the long journey enjoyable for all age groups."
},
{
"name": "Luxury Urbania Pune to Ayodhya",
"description": "Luxury Urbania Pune to Ayodhya delivers a premium travel experience with modern interiors, plush seating, and superior ride comfort, ideal for travelers seeking a refined pilgrimage journey."
},
{
"name": "Affordable Urbania Pune to Ayodhya",
"description": "Affordable Urbania Pune to Ayodhya provides cost-effective Urbania bus rental services without compromising on safety or comfort, making it suitable for budget-conscious pilgrims and group travelers."
},
{
"name": "Chauffeur Driven Urbania Pune to Ayodhya",
"description": "Chauffeur Driven Urbania Pune to Ayodhya ensures a stress-free and secure journey with trained, verified drivers who are experienced in long-distance and inter-state travel."
},
{
"name": "Pune Ayodhya Urbania Travel Service",
"description": "Pune Ayodhya Urbania Travel Service offers dependable and well-managed transportation solutions with a focus on comfort, safety, and customer satisfaction throughout the journey."
},
{
"name": "Best Urbania Hire Pune to Ayodhya",
"description": "Best Urbania Hire Pune to Ayodhya is known for quality vehicles, professional service, and consistent reliability, making it a preferred choice for Pune to Ayodhya travel."
},
{
"name": "Pilgrimage Urbania Hire Pune",
"description": "Pilgrimage Urbania Hire Pune specializes in religious and spiritual tours, offering clean Urbania buses, courteous chauffeurs, and well-planned travel arrangements for devotees."
},
{
"name": "Trusted Ayodhya Urbania Service",
"description": "Trusted Ayodhya Urbania Service delivers safe, dependable, and customer-focused Urbania bus rental services, ensuring a comfortable and spiritually enriching journey to Ayodhya."
}
],
"tableData": [
["Pune to Ayodhya Urbania Bus on Rent", "Ayodhya Urbania Hire from Pune"],
["Urbania Bus Rental Pune to Ayodhya", "Urbania AC Bus Pune to Ayodhya"],
["Pune Ayodhya Urbania One Way Hire", "Pune Ayodhya Urbania Round Trip Hire"],
["Corporate Urbania Pune to Ayodhya", "Family Tour Urbania Pune to Ayodhya"],
["Luxury Urbania Pune to Ayodhya", "Affordable Urbania Pune to Ayodhya"],
["Chauffeur Driven Urbania Pune to Ayodhya", "Pune Ayodhya Urbania Travel Service"],
["Best Urbania Hire Pune to Ayodhya", "Pilgrimage Urbania Hire Pune"],
["Trusted Ayodhya Urbania Service", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Pune to Ayodhya Urbania Bus On Rent for Comfortable Pilgrimage",
        "WhyChoosedescription": "Pune to Ayodhya Urbania Bus On Rent is ideal for devotees, families, and groups planning a long-distance spiritual journey to Ayodhya with comfort and convenience."
    },
    {
        "WhyChooseheading": "Spacious and Modern Urbania Buses",
        "WhyChoosedescription": "Our Urbania buses for Pune to Ayodhya travel are equipped with air-conditioning, comfortable reclining seats, ample legroom, and sufficient luggage space for long-distance journeys."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Long-Distance Routes",
        "WhyChoosedescription": "All drivers are trained and experienced in long-distance travel from Pune to Ayodhya, ensuring safe driving, timely arrivals, and a stress-free journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Pune to Ayodhya Urbania Bus On Rent offers competitive pricing with no hidden charges, making long-distance pilgrimage travel cost-effective."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated customer support for inquiries, reservations, and travel coordination."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Available for multi-day trips, pilgrimage tours, family travel, group journeys, and customized itineraries as per your schedule."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania buses are regularly cleaned, sanitized, and well-maintained to ensure passenger comfort and hygiene throughout the journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Our Pune to Ayodhya Urbania Bus On Rent service ensures on-time departures, reliable travel support, and a smooth overall experience."
    }
]
}
const faqData = [
    {
        question: 'Can Pune to Ayodhya Urbania Bus On Rent be booked for long-distance travel?',
        answer: 'Yes, it is suitable for long-distance pilgrimages, family trips, group journeys, and religious tours from Pune to Ayodhya.'
    },
    {
        question: 'How can I book Pune to Ayodhya Urbania Bus On Rent?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for quick and convenient reservations.'
    },
    {
        question: 'Why choose Pune to Ayodhya Urbania Bus On Rent?',
        answer: 'This service offers comfortable seating, experienced drivers, clean vehicles, flexible travel plans, and transparent pricing.'
    },
    {
        question: 'Are drivers experienced for the Pune to Ayodhya route?',
        answer: 'Yes, all drivers are licensed, trained, and experienced in long-distance routes including Pune to Ayodhya.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off locations are available across Pune and nearby areas.'
    },
    {
        question: 'Is Pune to Ayodhya Urbania Bus On Rent available 24/7?',
        answer: 'Yes, booking services and customer support are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained to ensure passenger safety.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey.'
    },
    {
        question: 'Is this service suitable for families and pilgrims?',
        answer: 'Yes, Pune to Ayodhya Urbania Bus On Rent is ideal for families, pilgrims, and group travelers.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ashok Mishra',
        feedback: 'Our Pune to Ayodhya pilgrimage was very comfortable. The Urbania bus was spacious, clean, and perfect for long-distance travel.',
        rating: 5
    },
    {
        id: 2,
        name: 'Mrs. Rekha Kulkarni',
        feedback: 'Excellent service and professional driver. Pune to Ayodhya Urbania Bus On Rent made our spiritual journey smooth and stress-free.',
        rating: 5
    }
];








































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ayodhya Urbania Bus On Rent",
  "image": "https://urbaniaonrentpune.in/assets/images/pune-ayodhya-urbania.jpg",
  "description": "Pune to Ayodhya Urbania Bus On Rent offers AC Urbania buses for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. Chauffeur-driven Urbania buses ensure safe, comfortable, and convenient transportation from Pune to Ayodhya.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/pune-to-ayodhya-urbania-bus-on-rent"
  }
};




    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Pune to Ayodhya Urbania Bus On Rent | AC Urbania Bus One Way & Round Trip 
  </title>

  <meta
    name="description"
    content="Book Pune to Ayodhya Urbania Bus On Rent for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. AC Urbania buses with chauffeur-driven service provide safe, comfortable, and convenient transportation from Pune to Ayodhya."
  />

  <meta
    name="keywords"
    content="Pune to Ayodhya Urbania Bus on Rent, Ayodhya Urbania Hire from Pune, Urbania Bus Rental Pune to Ayodhya, Urbania AC Bus Pune to Ayodhya, Pune Ayodhya Urbania One Way Hire, Pune Ayodhya Urbania Round Trip Hire, Corporate Urbania Pune to Ayodhya, Family Tour Urbania Pune to Ayodhya, Luxury Urbania Pune to Ayodhya, Affordable Urbania Pune to Ayodhya, Chauffeur Driven Urbania Pune to Ayodhya, Pune Ayodhya Urbania Travel Service, Best Urbania Hire Pune to Ayodhya, Pilgrimage Urbania Hire Pune, Trusted Ayodhya Urbania Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/86.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoayodhyaurbaniabus;